



































































import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { importPlanZip } from '../api/api';
import Datatable from './Datatable.vue';
import get from 'lodash/get';
import { BACKEND_URL } from '../helpers/constants';
import ButtonLoading from '@/components/ButtonLoading.vue';
import ImportZIPResult from '@/models/ImportZIPResult';

@Component({
    components: {
        ButtonLoading,
    },
})
export default class ImportPlans extends Vue {
    url: string | undefined = BACKEND_URL;
    @Model('update:activeModel') readonly activeModel!: boolean;
    active: boolean = false;
    sending: boolean = false;
    resultData: ImportZIPResult | null = null;
    view: 'import' | 'result' = 'import';

    @Watch('active')
    onActivel(value: boolean) {
        if (this.sending) {
            this.active = true;
        }
        if (!this.active) {
            this.view = 'import';
        }
        this.$emit('update:activeModel', value);
    }

    click() {
        if (this.sending) {
            return;
        }
        // @ts-ignore
        this.$refs.fileinput.click();
    }

    @Watch('activeModel')
    onActiveModel() {
        this.active = this.activeModel;
    }

    async fileChangeListener(ev: Event) {
        this.sending = true;

        const target = ev.target as HTMLInputElement;
        if (!target.files) {
            return;
        }
        const $vs = (this as any).$vs;
        const file = target.files[0] as File;
        try {
            const resp = await importPlanZip(
                +this.$route.params.programID,
                file
            );
            const resultData = resp.data;
            this.resultData = resultData;
            this.view = 'result';

            this.$emit('refresh');
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: `ZIP importé`,
                text: `Le ZIP a bien été importé`,
            });
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de l'importation du ZIP`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.sending = false;
        }
    }
}
